import React from "react";
import "./LogoutModal.scss";
// import Button from "../../atoms/Button/Button";

/**
 * Modal elegante y minimalista para confirmar cierre de sesión
 * @param {Object} props
 * @param {boolean} props.isOpen - Estado del modal
 * @param {Function} props.onConfirm - Callback al confirmar
 * @param {Function} props.onCancel - Callback al cancelar
 * @param {boolean} props.isLoading - Estado de carga
 */
const LogoutModal = ({ isOpen, onConfirm, onCancel, isLoading = false }) => {
    if (!isOpen) return null;

    return (
        <>
            <div className="logout-modal-overlay" onClick={onCancel}>
                <div
                    className="logout-modal"
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="logout-modal__icon">
                        <svg
                            width="64"
                            height="64"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                            <polyline points="16 17 21 12 16 7"></polyline>
                            <line x1="21" y1="12" x2="9" y2="12"></line>
                        </svg>
                    </div>

                    <h2 className="logout-modal__title">¿Cerrar sesión?</h2>
                    <p className="logout-modal__message">
                        Tu sesión se cerrará de forma segura. Podrás volver a
                        iniciar sesión en cualquier momento.
                    </p>

                    <div className="logout-modal__actions">
                        {/* <Button 
                            text={"Cancelar"}
                            className="outlet logout-modal__button--cancel"
                            onClick={onCancel}
                            disabled={isLoading}
                        />
                        <Button 
                            text={isLoading ? "Cerrando..." : "Cerrar sesión"}
                            className="degrad logout-modal__button--confirm"
                            onClick={onConfirm}
                            disabled={isLoading}
                        /> */}
                        <button
                            className="logout-modal__button logout-modal__button--cancel"
                            onClick={onCancel}
                            disabled={isLoading}
                        >
                            Cancelar
                        </button>
                        <button
                            className="logout-modal__button logout-modal__button--confirm"
                            onClick={onConfirm}
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <>
                                    <i className="pi pi-spin pi-spinner"></i>
                                    <span>Cerrando...</span>
                                </>
                            ) : (
                                "Cerrar sesión"
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default LogoutModal;
